module.exports = __webpack_public_path__ + "cover-letter-47f61a13/template-3-99e73a727f2c9c2b0832b9579570807b.jpg";